import { Box, Stack, Switch, Typography } from '@mui/material';

// Filter Chip Component
export interface FilterChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export const FilterChip = ({ label, active, onClick }: FilterChipProps) => (
  <Box
    component="button"
    onClick={onClick}
    sx={{
      whiteSpace: 'nowrap',
      px: 2.5,
      py: 1.25,
      borderRadius: '24px',
      border: active ? '1px solid' : '1px solid transparent',
      borderColor: active ? 'green.main' : 'transparent',
      fontSize: '13px',
      fontWeight: active ? 600 : 500,
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      position: 'relative',
      ...(active
        ? {
            backgroundColor: 'green.main',
            color: 'common.white',
          }
        : {
            backgroundColor: 'grey.800',
            color: 'grey.300',
            '&:hover': {
              backgroundColor: 'grey.700',
              borderColor: 'grey.600',
              transform: 'translateY(-1px)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            },
          }),
      '&:active': {
        transform: 'translateY(0)',
      },
    }}
  >
    {label}
  </Box>
);

// Filter Switch Component
export interface FilterSwitchProps {
  label: string;
  checked: boolean;
  onChange: () => void;
}

export const FilterSwitch = ({ label, checked, onChange }: FilterSwitchProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{
      backgroundColor: 'grey.800',
      borderRadius: '12px',
      px: 2,
      py: 1.5,
    }}
  >
    <Typography color="common.white" fontSize="14px">
      {label}
    </Typography>
    <Switch
      checked={checked}
      onChange={onChange}
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: 'green.main',
          '& + .MuiSwitch-track': {
            backgroundColor: 'green.main',
            opacity: 0.5,
          },
        },
        '& .MuiSwitch-track': {
          backgroundColor: 'grey.600',
        },
      }}
    />
  </Stack>
);
